export interface IDateOptions {
  extraDays: number;
}

export class DateService {
  public static validateDate(date: Date): boolean {
    const currentDate = new Date();

    return currentDate > date;
  }

  public static tryConvertToDate(dateString: string, options?: IDateOptions): Date | null {
    const dateParts = dateString.split('/');

    // Date Format is MM/DD/YYYY
    const month = parseInt(dateParts[0]);
    let day = parseInt(dateParts[1]);
    const year = parseInt(dateParts[2]);

    const isInvalid = isNaN(day) || isNaN(month) || isNaN(year);

    const extraDays = options?.extraDays ?? 0;

    day -= Math.abs(extraDays);

    if (isInvalid) {
      return null;
    }

    return new Date(year, month - 1, day);
  }

  public static isOldEnough(date: Date): boolean {
    const currentDate = new Date();

    const _14years = 14;

    currentDate.setFullYear(currentDate.getFullYear() - _14years);

    return currentDate > date;
  }
}
